<div class="section-card-container">
    <img [src]="card().imgLink">
    <div class="section-card-content">
        @if (type() == 'public-security') {
            <h3 class="update-text-subtitle">{{card().subtitle}}</h3>
            <h4 class="update-text-title">{{card().title}}</h4>
            <a class="update-text-link" [href]="card().link">Más información <fa-icon icon="chevron-right"></fa-icon> </a>
        } @else if (type() == 'private-security') {
            <h4 class="update-text-title">{{card().title}}</h4>
            <p class="update-text-content">{{card().content}}</p>
            <a class="update-text-link" [href]="card().link">Más información <fa-icon icon="chevron-right"></fa-icon> </a>

        }
    </div>

</div>
